import React from "react";
import { Box, Typography, Button, TextField, Grid, Paper, Switch, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const EtapaCargos = ({
  roles,
  onRolesChange,
  onGenerateRoles,
  isGenerating = false,
  errorMessage = "",
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%"}}>
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
        👥 Configurar Cargos e Permissões
      </Typography>

      <Typography variant="body1" gutterBottom>
        Aqui você configura os cargos principais da sua equipe. Depois, você poderá ajustar permissões detalhadas em
        Configurações &gt; Cargos.
      </Typography>

      {isGenerating ? (
        <CircularProgress />
      ) : (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Você pode gerar uma sugestão inicial de cargos com ajuda da IA e depois ajustar os nomes e descrições
            conforme a realidade da sua operação.
          </Typography>

          {errorMessage && (
            <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, border: `1px solid ${theme.palette.warning.light}`, backgroundColor: theme.palette.warning.light + "22" }}>
              <Typography variant="body2" color="warning.main">
                {errorMessage}
              </Typography>
            </Box>
          )}

          {(!roles || roles.length === 0) && (
            <Box sx={{ mb: 3, display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Button variant="contained" onClick={onGenerateRoles} disabled={isGenerating}>
                {isGenerating ? "Gerando cargos..." : "Gerar cargos sugeridos com IA"}
              </Button>
              <Button
                variant="outlined"
                onClick={() =>
                  onRolesChange([
                    { nome: "Gerente", descricao: "", ativo: true },
                    { nome: "Atendente", descricao: "", ativo: true },
                  ])
                }
              >
                Começar com cargos básicos
              </Button>
            </Box>
          )}

          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Cargos Sugeridos
          </Typography>

          {roles && roles.length > 0 ? (
            roles.map((cargo, index) => (
              <Paper key={index} sx={{ p: 2, mb: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Nome do Cargo"
                      value={cargo.nome}
                      onChange={(e) => {
                        const next = [...roles];
                        next[index] = { ...next[index], nome: e.target.value };
                        onRolesChange(next);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Switch
                      checked={cargo.ativo !== false}
                      onChange={(e) => {
                        const next = [...roles];
                        next[index] = { ...next[index], ativo: e.target.checked };
                        onRolesChange(next);
                      }}
                    />
                    <Typography variant="body2" component="span">
                      {cargo.ativo !== false ? "Ativo" : "Inativo"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Descrição (opcional)"
                      multiline
                      rows={2}
                      value={cargo.descricao || ""}
                      onChange={(e) => {
                        const next = [...roles];
                        next[index] = { ...next[index], descricao: e.target.value };
                        onRolesChange(next);
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            ))
          ) : (
            <Typography variant="body2">Nenhum cargo sugerido disponível.</Typography>
          )}

          {roles && roles.length > 0 && (
            <Box mt={2}>
              <Button
                variant="outlined"
                onClick={() => onRolesChange([...roles, { nome: "", descricao: "", ativo: true }])}
              >
                Adicionar novo cargo
              </Button>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default EtapaCargos;
